import { IListItem, IWatrRequest, IWatrReimbursement } from '@nkr/models/index';
import { ViewWrapper } from '../styles';
import ViewDonorRequestContent from './view-donor-request-content';

interface IProps {
    data: IWatrRequest,
    isAudit: boolean,
    reimbursements: IWatrReimbursement[],
    countryList?: IListItem[],
    openReconcileReimbursementEntry?: boolean,
    onUpdate: (
        reqId: number, firstName: string, lastName: string, email: string, mobilePhone: string, dob: string, expirationDate: string,
        achAccountNumber: string, achRoutingNumber: string, intBankingNumber: string, intSwiftNumber: string,
        nameOfBank: string, cityTownLocality: string, stateProvinceRegion: string, postalCode: string, additionalCode: string,
        bankCountry: number | null) => void,
}

const ViewDonorRequest = (props: IProps) => {
    return (
        <ViewWrapper>
            <div className='modal-container'>
                <ViewDonorRequestContent
                    data={props.data}
                    isAudit={props.isAudit}
                    reimbursements={props.reimbursements}
                    countryList={props.countryList}
                    openReconcileReimbursementEntry={props.openReconcileReimbursementEntry}
                    onUpdate={props.onUpdate}
                />
            </div>
        </ViewWrapper>
    );
}

export default ViewDonorRequest;